import { render, staticRenderFns } from "./view_AboutUs.vue?vue&type=template&id=ff80a57e&"
import script from "./view_AboutUs.vue?vue&type=script&lang=js&"
export * from "./view_AboutUs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports